﻿import { Component, EventEmitter, Output } from "@angular/core";
import { HashLocationStrategy, Location, LocationStrategy, CommonModule } from "@angular/common";
import { Router} from "@angular/router";
import { DataService } from "../services/dataService";

@Component({
    selector: "jax-externaluserfuturehearingcomponent",
    templateUrl: "./externalUserFutureHearing.component.html",
})
export class ExternalUserFutureHearingComponent {

    public data;
    public filterQuery = "";
    public rowsOnPage = 10;
    public sortBy = "HearingDateTime";
    public sortOrder = "asc";
    public totalRecord = 0;
    public isCompleted = false;
    public hasError = false;
    public errorMessage: string;
    public userId: number;
    public currentUser: any;
    public JSON : any;

    public searchFields: HearingSearchFields[] = new Array();
    public searchFieldId: string = "";

    constructor(private dataService: DataService, private router: Router) {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.userId = this.currentUser.UserId;
        }
        this.JSON = JSON;
    }

   public ngOnInit() {
       this.isCompleted = false,
           this.dataService.get("Cases/externaluserfuturehearings?UserId=" + this.userId).subscribe(
               (response) => {
                   this.data = response,
                       this.isCompleted = true,
                       this.totalRecord = this.data.length;
                   this.hasError = false;
                   this.errorMessage = "";
               },
               (error) => {
                   this.errorMessage = error.message;
                   this.isCompleted = true;
                   this.hasError = true;
               }
           );

       this.getSearchFields();
   }

  public onchange(pageEvent) {

        this.totalRecord = pageEvent.dataLength;
        this.rowsOnPage > 15 ? this.rowsOnPage = 10 : this.rowsOnPage = this.rowsOnPage;
   }

    public getSearchFields(): void {
        let hearingfield = new HearingSearchFields();
        this.searchFields.push(hearingfield);
        hearingfield = new HearingSearchFields();
        hearingfield.Id = "filterQuery0";
        hearingfield.Name = "HearingDateTime";
        hearingfield.Type = "Date";
        this.searchFields.push(hearingfield);

        hearingfield = new HearingSearchFields();
        hearingfield.Id = "filterQuery1";
        hearingfield.Name = "HearingType";
        this.searchFields.push(hearingfield);

        hearingfield = new HearingSearchFields();
        hearingfield.Id = "filterQuery2";
        hearingfield.Name = "CaseNumber";
        this.searchFields.push(hearingfield);

        hearingfield = new HearingSearchFields();
        hearingfield.Id = "filterQuery3";
        hearingfield.Name = "FirstName";
        this.searchFields.push(hearingfield);

        hearingfield = new HearingSearchFields();
        hearingfield.Id = "filterQuery4";
        hearingfield.Name = "MiddleName";
        this.searchFields.push(hearingfield);

        hearingfield = new HearingSearchFields();
        hearingfield.Id = "filterQuery5";
        hearingfield.Name = "LastName";
        this.searchFields.push(hearingfield);


        hearingfield = new HearingSearchFields();
        hearingfield.Id = "filterQuery6";
        hearingfield.Name = "DOB";
        hearingfield.Type = "Date";
        this.searchFields.push(hearingfield);
  }

    public getSelectedField(id:string) {
        var obj = this.searchFields.find(n => n.Id === id);
        return obj;
    }
}



export class HearingSearchFields {
    public Id: string;
    public Name: string;
    public Type: string;
    constructor() {
        this.Id = "";
        this.Name = "--Select--";
        this.Type = "string";
    }
}